import ProductorEstablecimientoLoteComponent from '../../components/relacion/ProductorEstablecimientoLote';

const ProductorEstablecimientoLotePage = () => {
  return <ProductorEstablecimientoLoteComponent />;
};

export default ProductorEstablecimientoLotePage;

